export const ACQUISITION_PANEL_DEFAULT_CHANNELS = [
  'CT_WEIGHT',
  'CIRC_PRESS',
  'WH_PRESS',
  'CT_CORR_DEPTH',
];
